import { render } from "./AnnouncementCreate.vue?vue&type=template&id=ec5dfd46&scoped=true"
import script from "./AnnouncementCreate.vue?vue&type=script&lang=js"
export * from "./AnnouncementCreate.vue?vue&type=script&lang=js"

import "./AnnouncementCreate.vue?vue&type=style&index=0&id=ec5dfd46&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ec5dfd46"

export default script